export default {
  title: {
    en: 'Subscription is paused',
  },
  text: {
    en: `
    Sorry, you can’t cancel your subscription while it’s paused. Please unpause your subscription first to cancel it.
  `,
  },
  button: {
    en: 'Unpause',
  },
}
